// extracted by mini-css-extract-plugin
export default {"wrapper":"b4-z","play":"c4-z"};